<template>
    <div v-if="contact" class="chat-group-feed">
        <div v-for="message in messages" :key="message.id" class="col-12">
            <div class="d-flex justify-content-start">
                <div class="card-message user-auth sent p-2 m-2" :style="{ backgroundColor: getColor(message.from) }">
                    <p class="m-0 mb-2">
                        <!-- O ID do contato aqui é o ID do grupo, e não identifica o usuário logado. -->
                        <span class="font-weight-bold float-left mr-3">
                            {{ message.from_contact ? message.from_contact.name : 'Usuário' }}
                        </span>
                        <small class="font-weight-light float-right">{{ message.created_at | moment('DD/MM/YYYY HH:mm') }}</small>
                    </p>
                    <div class="chat-message-body">
                        <p v-if="message.text" class="mb-1" v-html="message.text"></p>
                        <MessageAttachment :message="message" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="messages.length <= 0" class="col-12">
            <h3 class="text-muted">Diga olá no grupo 😀</h3>
        </div>
    </div>
    <div v-else class="text-center">
        <h3>Escolha um grupo ao lado para iniciar uma conversa.</h3>
    </div>
</template>

<script>
import MessageAttachment from './MessageAttachment';

export default {
    components: { MessageAttachment },
    props: {
        contact: { type: Object },
        type: { type: String },
        messages: { type: Array, required: true },
    },
    methods: {
        getColor(id) {
            // Cor clara estável por remetente, sem criar elementos <style> a cada renderização.
            const text = String(id);
            let hash = 0;

            for (let index = 0; index < text.length; index += 1) {
                hash = ((hash * 31) + text.charCodeAt(index)) | 0;
            }

            return `hsl(${Math.abs(hash) % 360}, 55%, 90%)`;
        },
    },
};
</script>

<style scoped>
.card-message {
    position: relative; display: flex; flex-direction: column; min-width: 0; max-width: 95%;
    word-wrap: break-word; color: #343435; background-clip: border-box;
    border: 1px solid #fdfdff !important; border-radius: 1rem;
}
.chat-message-body { overflow-wrap: anywhere; word-break: break-word; }
</style>
